import { CellEvent } from './report-table.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportOptionsService } from '../report-options/report-options.service';
import { Report } from '../../models/reports-model/report.model';
import { reportDataTable } from '../animations';
import { SortEvent } from 'primeng/components/common/sortevent';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss'],
  animations: [reportDataTable],
})
export class ReportTableComponent {
  @Input() report: Report;
  @Input() sortFieldValue: string = null;
  @Input() sortOrder: number = 1;
  @Input() rows = 100;
  @Input() tableIndex: boolean = true;
  @Input() usePagination: boolean;
  @Input() emptyMessage: string;
  @Input() expandable: boolean = false;
  @Input() dataKeyValue: string = '';
  @Input() useSearching: boolean = true;
  @Input() useExport: boolean = true;
  @Input() isHighlighted: (rowData: any) => boolean = () => false;
  @Input() useCustomClasses: (
    event: CellEvent
  ) => string | string[] | Object = () => '';
  @Input() useColumnDescriptions: (columnKey: string) => boolean = () => false;
  @Output() clickOnCell: EventEmitter<CellEvent> = new EventEmitter();

  constructor(
    private translateService: TranslateService,
    public reportOptionsService: ReportOptionsService
  ) {}

  translateColumnName(col: any) {
    // console.log(this.report.name);
    if (col.desc.toString().includes('Sensor')
      || col.key === 'time'
      || col.key === 'pharmacy'
      || col.key === 'baseStation'
      || col.key === 'resolver'
      || col.key === 'alarmType'
      || col.key === 'LP.'
      || col.key === 'sensor'
      || col.key === 'value'
      || col.key === 'description'
    ) {
      return this.translateService.instant(
        `reports.${this.report.name}.columns.${col.key}`
      );
    }
    return col.desc;
  }

  parseCandistance(candistanceValue) {
    return Number.parseInt(candistanceValue, 10);
  }

  highLightRows(rowData: any): boolean {
    return this.isHighlighted(rowData);
  }

  setCustomStyles(rowData: any, column: any): string | string[] | Object {
    return this.useCustomClasses({ rowData, column });
  }

  showColumnDescription(column: any): boolean {
    return this.useColumnDescriptions(column);
  }

  onClickOnCell(rowData: any, column: any) {
    this.clickOnCell.emit({ rowData, column });
  }

  filterByCols(): string[] {
    return this.report.columns.map((col) => col.key);
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      let result: number;

      if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;
    });
  }

  protected readonly console = console;
}
